<template>
  <div class="logout-page d-flex flex-column justify-content-center align-items-center mb-5">
    <template v-if="working">
      <p>{{ $t('auth.logout.processing') }}</p>
      <loading-spinner/>
    </template>
    <template v-else>
      <p>{{ $t('auth.logout.title') }}</p>
      <p>{{ $t('auth.logout.message') }}</p>
      <p v-if="!isEventsSite"><a href="/login">{{ $t('auth.logout.retrigger') }}</a></p>
    </template>
  </div>
</template>

<script>
import authMixin from '@src/mixins/auth';
import LoadingSpinner from '@/components/misc/LoadingSpinner';
import AuthLogoutMutation from '@/graphql/mutations/AuthLogout.gql';
import { mapRoot } from '@/mixins/root';

export default {
  props: {
    company: Object,
  },
  components: {
    LoadingSpinner,
  },
  mixins: [
    authMixin
  ],
  data: () => ({
    working: false,
  }),
  created() {
    const { path } = this.$route;
    if (path === '/logout') {
      this.working = true;
    }
  },
  metaInfo() {
    return {
      title: this.working ? this.$t('auth.logout.processing') : this.$t('auth.logout.title'),
      bodyAttrs: {
        class: [ 'bg-white' ],
      },
    };
  },
  mounted() {
    this.triggerLogout();
  },
  computed: {
    ...mapRoot([ 'adminOrigin', 'isEventsSite' ]),
    cognitoLogoutUrl() {
      const { cognito } = this.company;
      const { origin } = this.$root;
      const { poolDomain, clientID } = cognito || {};

      return origin && poolDomain && clientID
        ? `${poolDomain.replace('/authorize', '')}/logout?client_id=${clientID}&logout_uri=${origin}/logout/confirm`
        : null;
    },
  },
  methods: {
    async triggerLogout() {
      try {
        const { id: companyID } = this.company;
        const { name, path } = this.$route;
        this.working = true;

        if (this.getToken()) {
          // Trigger the logout mutation
          await this.$apollo.mutate({ mutation: AuthLogoutMutation }).catch(err => this.$log.error(err));
        }
        // Clear the session data
        this.clearAuth();

        if (name === 'LogoutAdmin') {
          window.location = `${this.adminOrigin}/${companyID}/logout`;
        } else if (process.env.NODE_ENV === 'production' && path === '/logout' && this.cognitoLogoutUrl) {
          window.location = this.cognitoLogoutUrl;
        } else {
          this.working = false;
        }
      } catch (err) {
        this.$notifyErr(err);
      }
    },
  },
};
</script>

<style lang="scss">
.logout-page {
  a {
    color: #0085ff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Auth/Logout.vue